import React from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import AppBar from "@material-ui/core/AppBar";
import Toolbar from "@material-ui/core/Toolbar";
import withStyles from "components/with-styles";
import styles from "./styles/navigation-bar.css.js";

const NavigationBar = ({ children, classes, open }) => (
  <AppBar
    position="absolute"
    className={cn(classes.dashboard_navigationbar, open && classes.dashboard_navigationbar__shift)}
  >
    <Toolbar className={cn(classes.navigationBar, classes.dashboard_header_content)}>{children}</Toolbar>
  </AppBar>
);

NavigationBar.propTypes = {
  /**
   * Indica si el menú lateral del dashboard está desplegado
   **/
  open: PropTypes.bool,
};

export default withStyles(styles)(NavigationBar);
